<template>
    <div class="col-md">
        <h3 class="text-secondary">For Added Security</h3>
        <p class="mb-1">
            Due to the nature of our service, iWebVisit requires two-factor
            authentication to be setup via a unique device for the safety of the
            inmate and the visitor.
            <b>
                To use this service, visitors must opt in to receive a
                verification code
            </b>
        </p>

        <p class="mt-3 pt-3">
            SMS messages may also be used for visitors in need of password
            recovery. Mobile messages and data rates may apply.
        </p>

        <div class="custom-control custom-checkbox my-5">
            <input
                id="receive-sms-checkbox"
                v-model="profileModel.can_receive_sms"
                :class="[
                    arrayExists(validationErrors.can_receive_sms)
                        ? 'is-invalid'
                        : '',
                    'custom-control-input',
                ]"
                type="checkbox"
            />
            <label
                class="custom-control-label pt-1 pt-md-0"
                for="receive-sms-checkbox"
            >
                I opt in to receiving SMS text messages from iWebVisit.com
            </label>

            <div
                v-for="(err, idx) in validationErrors.can_receive_sms"
                :key="idx"
                :class="[invalidClasses]"
            >
                {{ err }}
            </div>
        </div>

        <p>You will be sent a temporary verification code once you submit.</p>

        <div
            v-if="profileModel.can_receive_sms && !isSpecialNumber"
            class="row"
        >
            <div class="col-auto mb-4">
                <div
                    class="row align-items-center justify-content-center text-center"
                >
                    <div class="col-auto">
                        <img src="@/assets/images/icon-phone-blue.png" alt="" />
                    </div>

                    <div class="col-auto">
                        <label class="text-secondary pt-1 pt-md-0">
                            Sending an SMS text to:
                            {{ phone }}
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- This technically doesn't belong here, but it's easier to display it. -->
        <div v-if="isCreating" class="row my-5">
            <div class="col-auto">
                By creating an account, you also agree to the terms of our
                <span class="text-primary font-weight-bold">
                    <router-link
                        :to="{
                            name: addMessagingRouting + 'acceptable-use-policy',
                            hash: '#anchor',
                        }"
                        target="_blank"
                    >
                        ACCEPTABLE USE policy.
                    </router-link>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { errorHandling } from '@/mixins/error-handling';
import { notify } from '@/mixins/notify';
import { routing } from '@/mixins/routing';

export default {
    mixins: [errorHandling, notify, routing],
    props: {
        model: {
            type: Object,
            required: true,
        },
        phone: {
            type: String,
            required: true,
        },
        isSpecialNumber: {
            type: Boolean,
            required: false,
            default: false,
        },
        isCreating: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['can-receive-sms'],
    data() {
        return {
            profileModel: this.model,
            invalidClasses: 'invalid-feedback alert alert-danger mt-2 mb-0',
        };
    },
    watch: {
        'profileModel.can_receive_sms'(value) {
            this.$emit('can-receive-sms', value);
        },
    },
};
</script>
